import React, { useContext, useEffect } from 'react';

import HeaderWithCTA from '@components/header-with-cta';
import AppLayout from '@layouts/AppLayout';
import { StateContext } from '@store/store';
import HomepageSEO from '@components/common/SEO/HomepageSEO';

function ProductDemo() {
  const globalState = useContext(StateContext);
  const { platform, os, config } = globalState;

  useEffect(() => {
    function calendalyScript(i: any, t: any, src: string) {
      let e;
      (e = i.createElement('script')).id = t;
      e.async = !0;
      e.src = src;
      // e.onload = cb;
      i.head.appendChild(e);
    }
    calendalyScript(
      document,
      'calendly-inline-widget',
      'https://assets.calendly.com/assets/external/widget.js',
    );
  }, []);

  return (
    <AppLayout platform={platform}>
      <HomepageSEO
        seo={{
          Title: 'Product Demo | invideo',
          Description:
            'invideo is an online video creator, that enables anyone to create high quality content and marketing videos, video ads for digital platforms.',
          CanonicalURL: 'https://invideo.io/product-demo/',
          Keywords: '',
          Hreflang: [],
          Meta: [],
          id: 0,
          RobotIndex: null,
          RobotFollow: null,
        }}
      />

      <HeaderWithCTA />
      <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/invideodemo/invideo-prd-demo"
        style={{
          minWidth: '320px',
          height: '1px',
          minHeight: 'calc(100vh - 70px)',
        }}
      />
    </AppLayout>
  );
}

export default ProductDemo;
